module.exports = __webpack_public_path__ + "img/sprint.0b9505f9.png";